import React from "react";
import PropTypes from "prop-types";
import {ReactComponent as DotIcon} from "connectui/icons/dot.svg";
import Text from "connectui/component/display/Text";
import {useTheme} from "connectui/theme/ThemeProvider";
import ChipIconText from "connectui/component/display/chip/ChipIconText";
import SvgIcon from "connectui/component/display/SvgIcon";

// TODO: Remove this to favour of StatusIcon
const StatusChip = ({text, type, icon = null, clickable = false}) => {
  const {theme} = useTheme();

  return (
    <ChipIconText
      text={
        <Text
          variant="textXS"
          weight="medium"
          color={`${type}700`}
          sx={{paddingLeft: theme.spacing(1)}}
        >
          {text}
        </Text>
      }
      icon={<SvgIcon component={icon || DotIcon} />}
      sx={{
        padding: theme.spacing(0.5, 2),
        backgroundColor: theme.colors[`${type}50`],
        color: theme.colors[`${type}700`],
        fill: theme.colors[`${type}700`],
        "&:hover": {
          backgroundColor: clickable
            ? theme.colors[`${type}200`]
            : theme.colors[`${type}50`],
        },
        "&:focus": {
          outline: `2px solid ${theme.colors[`${type}200`]}`,
          outlineOffset: "2px",
        },
      }}
    />
  );
};

StatusChip.propTypes = {
  text: PropTypes.string.isRequired,
  type: PropTypes.oneOf(["error", "warning", "success", "blue", "gray"]),
  icon: PropTypes.node,
  clickable: PropTypes.bool,
};

export default StatusChip;
